import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  updateTime: null,
  participantQuestions: [],
  all_Event_Catogaries: [],
  navigeteNextSlide: "1",
  active_steps: "1",

  step_Activateion: 1,

  //
  //
  //
  //
  //
  //
  //
  //
  // // ----- event properties ------
  // eventName: "",
  // eventDescription: "",
  // eventCatogary: "",
  //
  // makePrivate: false,
  //
  // startTime: "",
  // endTime: "",
  //
  // eventIcon: "",
  // attachmentsEventBrochure: "",
  //
  // hasSubEvents: true,
  // subEvents: [],
  //
  // location_name: "",
  // longitide: "",
  // latitude: "",
  //
  // session: [],
  //
  //









  // new codes

  event_id: "",
  has_sub_events: "",
  sub_event_id: "",

  Event_Table_data: {
    columns: [
      {
        label: 'Name',
        field: 'Name',
        sort: 'asc'
      },
      {
        label: 'Start Date',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Date',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'Privacy',
        field: 'privacy',
        sort: 'asc'
      },
      {
        label: 'Has Sub Events',
        field: 'Has_sub',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      },
    ],
    unpublish_columns: [
      {
        label: 'Name',
        field: 'Name',
        sort: 'asc'
      },
      {
        label: 'Privacy',
        field: 'privacy',
        sort: 'asc'
      },
      {
        label: 'Has Sub Events',
        field: 'Has_sub',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      },
    ],
  },


  allEventsObj: {
    success: true,
    eventList: {
      event:
        // null
        [
        {
          event_id: 1,
          event_name: "13th National Cyber Security Week 2020",
          description: "Here, describe more about the event.",
          has_sub_event: false,
          privacy: "PRIVATE",
          start_time: "2020-06-02 06:00:00",
          end_time: "2020-08-02 06:30:00",
          icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
          brochure: "brochure image url",
          qr_code: "QR Code",
          category_id: 1,
          corporate_id: 12332,
          created_by: 1221,
          event_contact_list: [
            {
              event_contact_id: 112233,
              name: "Pathum",
              email: "pathum@gmail.com",
              contact: "0775544323"
            }
          ],
          subEvents: [
            {
              sub_event_id: 123456,
              name: "Sport day at Ceyentra",
              description: "Here, describe more about the event.",
              category_id: 1,
              privacy: "PRIVATE",
              start_time: "2020-06-02 06:00:00",
              end_time: "2020-08-02 06:30:00",
              icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
              brochure: "brochure image url",
              qr_code: "QR Code",
              invitation_image: "invitation image url",
              invitation_text: "request to event",
              is_sub_event: true,
              location_name: "Galle",
              latitude: 6.9270786,
              longitude: 79.861243,
              event_contact_list: [
                {
                  event_contact_id: 112233,
                  name: "Pathum",
                  email: "pathum@gmail.com",
                  contact: "0775544323"
                }
              ]
            }
          ]
        },
        {
          event_id: 2,
          event_name: "15th National Cyber Security Week 2020",
          description: "Here, describe more about the event.",
          has_sub_event: true,
          privacy: "PRIVATE",
          start_time: "2020-06-02 06:00:00",
          end_time: "2020-06-02 22:00:00",
          icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
          brochure: "https://www.tutorialspoint.com/java/java_tutorial.pdf",
          qr_code: "QR Code",
          category_id: 1,
          corporate_id: 12332,
          created_by: 1221,
          event_contact_list: [
            {
              event_contact_id: 112233,
              name: "Pathum",
              email: "pathum@gmail.com",
              contact: "0775544323"
            }
          ],
          subEvents: [
            {
              sub_event_id: 123456,
              name: "15th National Cyber Security Week 2020 - Night Camp",
              description: "Here, describe more about the event.",
              category_id: 1233,
              privacy: "PRIVATE",
              start_time: "2020-06-02 06:00:00",
              end_time: "2020-08-02 06:00:00",
              icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
              brochure: "brochure image url",
              qr_code: "QR Code",
              invitation_image: "invitation image url",
              invitation_text: "request to event",
              is_sub_event: true,
              location_name: "Galle",
              latitude: 6.9270786,
              longitude: 79.861243,
            }
          ]
        },
        {
          event_id: 3,
          event_name: "16th National Cyber Security Week 2020   this",
          description: "Here, describe more about the event.",
          has_sub_event: true,
          privacy: "PUBLIC",
          start_time: "2020-06-02 06:00:00",
          end_time: "2020-06-02 22:00:00",
          icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
          brochure: "https://www.tutorialspoint.com/java/java_tutorial.pdf",
          qr_code: "QR Code",
          category_id: 1,
          corporate_id: 12332,
          created_by: 1221,
          event_contact_list: [
            {
              event_contact_id: 112233,
              name: "Pathum",
              email: "pathum@gmail.com",
              contact: "0775544323"
            }
          ],
          subEvents: []
        },
        {
          event_id: 4,
          event_name: "16th National Cyber Security Week 2020 - IIT",
          description: "Here, describe more about the event.",
          has_sub_event: false,
          privacy: "PUBLIC",
          start_time: "2020-06-02 06:00:00",
          end_time: "2020-06-02 22:00:00",
          icon: "https://eventtags-test.dialog.lk/resources/event/images/icon/c307849e-a1a2-40c7-bcac-31199e837681.png",
          brochure: "brochure image url",
          qr_code: "QR Code",
          category_id: 1,
          corporate_id: 12332,
          created_by: 1221,
          event_contact_list: [
            {
              event_contact_id: 112233,
              name: "Pathum",
              email: "pathum@gmail.com",
              contact: "0775544323"
            }
          ],
          subEvents: []
        }
      ]
    }
  },

  //--------------------------------------------------------------------------------------------------------------------
  //current data
  current_event_id:"",

  current_event: "",

  current_sub_event_id: '',

  currentSubEventId: '',

  current_sub_events: [],

  pg: 1,

};

const reducer = (state = initialState, action) => {

  let se = null;

  switch (action.type) {
    case actionTypes.STORE_EVENT_DETAILS:

      let activeStep = 1;

      if(action.value.navigateNextSlide === "2"){
        activeStep = 2;
      }else{
        activeStep = 3;
      }

      return {
        ...state,

        step_Activateion: activeStep,

        eventName: action.value.eventName,
        eventDescription: action.value.eventDescription,
        navigeteNextSlide: action.value.navigateNextSlide,
        makePrivate: action.value.makePrivate,
        eventCatogary: action.value.catogary,

        startTime: action.value.startTime,
        endTime: action.value.endTime,

        hasSubEvents: action.value.hasSubEvents,

        eventIcon: action.value.eventIcon,
        attachmentsEventIcon: action.value.eventIcon,

      //   eventDescription: action.value.eventDescription,
      // eventCatogary: action.value.eventCatogary,
      // makePrivate: action.value.makePrivate,
      // startDate: action.value.startDate,
      // endDate: action.value.endDate,
      // startTime: action.value.startTime,
      // endTime: action.value.endTime,
      // attachmentsEventIcon: action.value.attachmentsEventIcon,
      // attachmentsEventInvitation: action.value.attachmentsEventInvitation,
      // attachmentsEventBrochure: action.value.attachmentsEventBrochure,
      // hasSubEvents: action.value.hasSubEvents,
      // subEvents: action.value.subEvents,
      // location_name: action.value.location_name,
      // longitide: action.value.longitide,
      // latitude: action.value.latitude,
      // session: action.value.session
      };

    case actionTypes.ALL_EVENT_CATOGARIES:
      return {
        ...state,
        all_Event_Catogaries: action.value
      };
    case actionTypes.EVENT_PARTICIPANT_QUESTION:
      return {
        ...state,
        participantQuestions: action.value
      };
    case actionTypes.EVENT_PARTICIPANT_QUESTION_UPDATE_TIME:
      return {
        ...state,
        updateTime: new Date().getTime()
      };
    case actionTypes.STORE_SUB_EVENT_DETAILS:
      let sub_events = state.subEvents;
      sub_events.push(action.value);
      return {
        ...state,
        subEvents: sub_events
      };

    case actionTypes.CHANGE_CREATE_EVENT_STEP:
      return {
        ...state,
        navigeteNextSlide: action.value
      };

    case actionTypes.DELETE_SUB_EVENT:
      se = state.subEvents;

      se.splice(action.value, 1);

      return {
        ...state,
        subEvents: se
      };

    case actionTypes.UPDATE_SUB_EVENT:
      se = state.subEvents;

      se.splice(action.value.index, 1);
      se.splice(action.value.index, 0, action.value.s_event);

      return {
        ...state,
        subEvents: se
      };

    case actionTypes.CHANGE_HAS_SUB_EVENTS:
      return {
        ...state,
        hasSubEvents: action.value
      };

      case actionTypes.ADD_AGENDA:


        if(action.value.mode) {

          se = state.subEvents;

          se.splice(action.value.index, 1);
          se.splice(action.value.index, 0, action.value.data);

          return {
            ...state,
            subEvents: se
          }

        }else{

          return {
            ...state,
            session: action.value.data
          }

        }

      return {
        ...state,
        step_Activateion: action.value
      };




//----------------------------------------------------------------------------------------------------------------------

    case actionTypes.CHANGE_ACTIVATION_OF_STEP:
      return {
        ...state,
        pg: action.value
      };

    case actionTypes.REMOVE_CURRENT_EVENT_FROM_REDUX:
      return {
        ...state,
        current_event: "",
        current_event_id: ""
      };

    case actionTypes.SET_CURRENT_EVENT_DATA:

      return {
        ...state,
        current_event: action.value,
        // current_event_id: action.value.event_id
      };

      case actionTypes.SET_CURRENT_SUB_EVENTS_DATA:
      return {
        ...state,
        current_sub_events: action.value,
        // current_event_id: action.value.event_id
      };

    case actionTypes.SET_CURRENT_SUB_EVENT:
      return {
        ...state,
        current_sub_event_id: action.value
      };

    case actionTypes.SET_CURRENT_SUB_EVENT_ID:
      return {
        ...state,
        currentSubEventId: action.value
      };

    default:
      return state;
  }
};

export default reducer;

